<template>
    <AppChartWrapper
            :imageName="name"
            :hideIcon="true"
    >
        <h4 class="subheading text-xs-left font-weight-regular section-title--color" slot="title">
            {{ name | unescapeString }}
        </h4>
        <div class="pt-3" slot="chart" style="min-height: 350px; padding: 0 0 20px;" v-if="summaryDataReady">
            <vue-word-cloud
                    :words="emojiCloud"
                    font-family="Roboto"
                    style="min-width: 400px; min-height: 350px; margin-top: -25px;"
                    v-if="emojiCloud.length > 0"
            ></vue-word-cloud>
            <div
                    class="text-xs-center d-flex fill-height align-center"
                    style="height: 325px"
                    v-else
            >
                            <span class="font-weight-bold display-1"
                                  style="color:#AFBAC8">Topic Cloud Data Not Found</span>
            </div>
        </div>
    </AppChartWrapper>
</template>

<script>
	import {mapState} from 'vuex';
	import VueWordCloud from "vuewordcloud";
    import downloadChart from "@/mixins/downloadChart";
	import AppChartWrapper from "../AppChartWrapper";

	export default {
		name: "EmojiCloud",
		components: {
			AppChartWrapper,
			[VueWordCloud.name]: VueWordCloud
		},
        mixins:[downloadChart],
		props: {
			summaryDataReady: {
				type: Boolean,
				required: true
			},
			name: {
				type: String,
			}
		},
		computed: {
			...mapState({
				emojiFilterList: state => state.emojiFilterList.slice(0, 50)
			}),

			emojiCloud() {
				let total = this.emojiFilterList.reduce((acc, cur) => acc + cur.count, 0);
				return this.emojiFilterList.map((item, index, arr) => {
					if (!item.count) return undefined;
					let maxFontWeight = 30;
					let weight = Math.floor((item.count / total) * maxFontWeight);
					let logValue = Math.floor(Math.log(item.count));
					weight = weight === 0 ? logValue : weight + logValue;
					weight = weight > maxFontWeight ? maxFontWeight : weight;
					return {
						text: item.emoji,
						weight
					}
				}).filter(item => !!item);
			}
		}
	}
</script>

<style scoped>

</style>
